import(/* webpackMode: "eager", webpackExports: ["FilterPageType","NewProducts","default"] */ "/builds/dustintech/products/openweb-nordics/web/libraries/dustin-microsite/apps/productsite/src/components/filters/filter-page-layout.tsx");
